export const CustomerContactsResource = {
  name: "Customer Contacts",
  path: "/sales/customer-contacts",
  access: ["read-customercontacts"],
};
